import React, { Component } from "react";


class BankReference extends Component {
    constructor(props) {
        super(props)
        this.state = {
            counter : 1,
            formData: [{ InstitutionName: '', CheckingAccountNumber: '', Address: '', Phone: '' }]
           
        }
    }
    //componentDidUpdate() {

    //    for (var i = 0; i < this.state.counter; i++) {
    //        children.push(<AddForm key={i} />)
    //    }
    //}
    handleAddFormData = () => {
        this.setState({
            formData: this.state.formData.concat([{ InstitutionName: '', CheckingAccountNumber: '', Address: '', Phone :'' }]),
            counter: this.state.counter + 1
        });
    }
    handleRemove = (index) => {
        this.setState({
            counter: index - 1,
            formData: this.state.formData.filter((s, _index) => index !== _index)
        });
    }
    handleNameChange = evt => {
        this.setState({ institutionName: evt.target.value });
    };

    handleFormDataNameChange = index => evt => {
        const newFormData = this.state.formData.map((formData, _index) => {
            if (index !== _index) return formData;
            return { ...formData, [evt.target.name]: evt.target.value };
        });
        this.setState({ formData: newFormData }, () => {
            this.props.onChange(evt, this.state.formData);
        });
    };
   
    render() {
        
        //const children = [];

        //for (var i = 0; i < this.state.counter; i += 1) {
        //    children.push(<AddForm key={i} number={i} handleChange={(value,i) => this.handleChange(value,i)} />);
        //};
        return (
            <form>
                <div className="row">
                    {this.state.formData.map((formData, index) => (
                        <div className="col-md-4">
                            {index !== 0 ?
                                <h6>Bank Reference - {index + 1} <a class="pull-right" onClick={() => this.handleRemove(index)}><i class="batch-icon batch-icon-remove"></i></a></h6> :
                                <h6>Bank Reference - {index + 1} </h6>}
                            <div class="form-group">
                                <hr />
                            </div>
                            <div className="form-group">
                                <label className="control-label">
                                    Institution Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    onChange={this.handleFormDataNameChange(index)}
                                    name="InstitutionName"
                                    id="InstitutionName"
                                />
                            </div>
                            <div className="form-group">
                                <label className="control-label">
                                    Checking Account #
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    onChange={this.handleFormDataNameChange(index)}
                                    name="CheckingAccountNumber"
                                    id="CheckingAccountNumber"
                                />
                            </div>
                            <div className="form-group">
                                <label className="control-label">
                                    Address
                                </label>
                                <textarea className="form-control"
                                    name="Address"
                                    onChange={this.handleFormDataNameChange(index)}
                                    id="Address" />
                            </div>
                            <div className="form-group">
                                <label className="control-label">
                                    Phone Number
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="Phone"
                                    id="Phone"
                                    onChange={this.handleFormDataNameChange(index)}
                                />
                            </div>
                        </div>
                    ))}
                    
                </div>
                <div class="row">
                    <div class="col-md-1">
                        <button class="btn btn-secondary" onClick={() => this.props.onPreviousPage()}><i class="batch-icon batch-icon-arrow-left"></i></button>
                    </div>
                    <div class="col-md-4"></div>
                    <div class="col-md-2 text-center">
                        <button type="button" class="btn btn-primary" onClick={() => this.handleAddFormData()}><i class="batch-icon batch-icon-add"></i></button>
                        
                    </div>
                    <div class="col-md-4"></div>
                    <div class="col-md-1"><button class="btn btn-primary" onClick={() => this.props.onNextPage()}> Next </button>
                    </div>
                </div>
            </form>
        );
    }
}
export default BankReference;


// WEBPACK FOOTER //
// ./src/view/Creditability/BankReference.jsx